import { AchievementIcon, CalendarIcon, DashboardIcon, MasterDataIcon, AttendanceIcon, CouponIcon, PaperclipIcon } from 'Asset/icon/index';

import Home from 'View/monitoring';
import ForbiddenPage from 'View/forbidden';
import ForbiddenSchedule from 'View/forbidden-schedule';
import ForgotPassword from 'View/forgot-password';
import Host from 'View/host';
import HostDetail from 'View/host-detail';
import HostSchedule from 'View/host-schedule';
import LiveAccount from 'View/live-account';
import Login from 'View/login';
import Report from 'View/report';
import RescheduleForm from 'View/reschedule-form';
import RescheduleDetail from 'View/reschedule-detail';
import ResetPassword from 'View/reset-password';
import Access from 'View/role';
import FormUpsertRoleView from 'View/role/section/form-upsert';
import RoleProvider from 'View/role/state';
import Schedule from 'View/schedule';
import RequestApproval from 'View/reschedule';
import Studio from 'View/studio';
import Target from 'View/target';
import User from 'View/user';
import FormUpsertUserView from 'View/user/section/form-upsert';
import UserProvider from 'View/user/state';
import Version from 'View/version';
import ReportAttendance from 'View/report-attendance';
import ReportAttendanceOperator from 'View/report-attendance-operator';
import ReportAttendanceOperatorDetail from 'View/report-attendance-operator-detail';
import StockPromo from 'View/stock-promo';
import HostHelpPartner from 'View/host-help-partner';
import ReportHelpPartner from 'View/report-help-partner';
import ScheduleGenerate from 'View/schedule-generate';
import ScheduleRuleset from 'View/schedule-ruleset';
import HostStockPromo from 'View/host-stock-promo';
import ShopeeCallback from 'View/shopee-callback';
import HostAchievementDetail from 'View/host-achievement-detail';
import HostTaskSubmission from 'View/host-task-submission';
import ReportHostTasks from 'View/report-host-tasks';
import HostAttendance from 'View/host-attendance-record';
import HostStream from 'View/host-stream';
import HostPresenceContent from 'View/host-presence-content';
import BriefLiveHost from 'View/productivity-host';
import ReportAttendanceHostDetail from 'View/report-attendance-host-detail';
import ScheduleChangeHost from 'View/schedule-change-host';
import BriefLive from 'View/brief-live';
import GiveawayForm from 'View/brief-live/section/giveaway-form';
import TalkingPointUpsertProvider from 'View/brief-live/state/talkingPointState';
import FormUpsertTalkingPointView from 'View/brief-live/section/talking-point-form-upsert';

export const routeList = [
  {
    path: 'login',
    name: 'Login',
    id: 'login',
    showInSideBar: false,
    children: [
      {
        path: '',
        id: 'login',
        element: <Login />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: 'forgot-password',
    name: 'Forgot Password',
    showInSideBar: false,
    children: [
      {
        path: '',
        id: 'forgot-password',
        element: <ForgotPassword />,
      },
    ],
  },
  {
    path: 'reset-password/:token',
    name: 'Reset Password',
    showInSideBar: false,
    children: [
      {
        path: '',
        id: 'reset-password',
        element: <ResetPassword />,
      },
    ],
  },
  {
    path: '/',
    icon: <DashboardIcon color="var(--color-semantic-text)" />,
    iconActive: <DashboardIcon color="var(--color-info60)" />,
    showInSideBar: true,
    exact: true,
    id: 'main-dashboard',
    name: 'Dashboard',
    children: [
      {
        path: '',
        id: 'main-dashboard',
        name: 'Dashboard',
        element: <Home />,
        showInSideBar: false,
      },
    ],
  },

  {
    path: '/schedule',
    icon: <CalendarIcon color="var(--color-semantic-text)" />,
    iconActive: <CalendarIcon color="var(--color-info60)" />,
    showInSideBar: true,
    exact: true,
    id: 'schedule',
    name: 'Schedule',
    children: [
      {
        path: 'calendar',
        id: 'schedule',
        name: 'Manage Schedule',
        element: <Schedule />,
        showInSideBar: true,
      },
      {
        path: 'approval-reschedule',
        id: 'request-approval',
        name: 'Request Approval',
        element: <RequestApproval />,
        showInSideBar: true,
      },
      {
        path: 'approval-reschedule/:id',
        id: 'reschedule-detail',
        name: 'Reschedule Detail',
        element: <RescheduleDetail />,
        showInSideBar: false,
      },
      {
        path: 'smart-schedule',
        id: 'smart-schedule',
        name: 'Smart Schedule',
        element: <ScheduleGenerate />,
        showInSideBar: false,
      },
      {
        path: 'change-host',
        id: 'change-host',
        name: 'Change Host',
        element: <ScheduleChangeHost />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/brief-live',
    icon: <PaperclipIcon color="var(--color-semantic-text)" />,
    iconActive: <PaperclipIcon color="var(--color-info60)" />,
    showInSideBar: true,
    exact: true,
    id: 'brief-live',
    name: 'Brief Live',
    children: [
      {
        path: '',
        id: 'brief-live',
        name: 'Brief Live',
        element: <BriefLive />,
        showInSideBar: true,
      },
      {
        path: 'giveaway/create',
        id: 'create-giveaway-brief-host',
        name: 'Giveaway Brief Host',
        element: <GiveawayForm />,
        showInSideBar: false,
      },
      {
        path: 'giveaway/update/:id',
        id: 'brief-host',
        name: 'Brief Host',
        element: <GiveawayForm />,
      },
      {
        path: 'talking-point/upsert/:id?',
        id: 'talking-point-upsert',
        name: 'Talking Point Upsert',
        element: <TalkingPointUpsertProvider children={<FormUpsertTalkingPointView />} />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/achievement',
    icon: <AchievementIcon color="var(--color-semantic-text)" />,
    iconActive: <AchievementIcon color="var(--color-info60)" />,
    showInSideBar: true,
    exact: true,
    id: 'achievement',
    name: 'Achievement',
    children: [
      {
        path: 'report-live',
        id: 'reporting',
        name: 'Report Live',
        element: <Report />,
        showInSideBar: true,
      },
      {
        path: 'target',
        id: 'target',
        name: 'Target',
        element: <Target />,
        showInSideBar: true,
      },
    ],
  },
  {
    path: '/master-data',
    icon: <MasterDataIcon color="var(--color-semantic-text)" />,
    iconActive: <MasterDataIcon color="var(--color-info60)" />,
    showInSideBar: true,
    exact: true,
    name: 'Data Setting',
    id: 'master-data',
    children: [
      {
        path: 'schedule-ruleset',
        id: 'schedule-ruleset',
        name: 'Schedule Ruleset',
        element: <ScheduleRuleset />,
        showInSideBar: true,
      },
      {
        path: 'user',
        id: 'user',
        name: 'User',
        element: <User />,
        showInSideBar: true,
      },
      {
        path: 'user/upsert/:id?',
        id: 'user-upsert',
        name: 'Upsert User',
        element: <UserProvider children={<FormUpsertUserView />} />,
        showInSideBar: false,
      },
      {
        path: 'account-livestream',
        id: 'account-livestream',
        name: 'Account',
        element: <LiveAccount />,
        showInSideBar: true,
      },
      {
        path: 'access',
        id: 'access',
        name: 'Role',
        element: <Access />,
        showInSideBar: true,
      },
      {
        path: 'studio',
        id: 'studio',
        name: 'Studio',
        element: <Studio />,
        showInSideBar: true,
      },
      {
        path: 'access/upsert/:id?',
        id: 'access-upsert',
        name: 'Upsert Role',
        element: <RoleProvider children={<FormUpsertRoleView />} />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/report',
    icon: <AttendanceIcon color="var(--color-semantic-text)" />,
    iconActive: <AttendanceIcon color="var(--color-info60)" />,
    showInSideBar: true,
    exact: true,
    id: 'reporting',
    name: 'Report',
    children: [
      {
        path: 'attendance',
        id: 'attendance-report',
        name: 'Absensi',
        element: <ReportAttendance />,
        showInSideBar: true,
      },
      {
        path: 'operator-attendance/:id',
        id: 'absensi-detail',
        element: <ReportAttendanceOperator />,
        showInSideBar: false,
      },
      {
        path: 'operator-attendance/:id/:date',
        id: 'absensi-operator-detail-spv',
        element: <ReportAttendanceOperatorDetail />,
        showInSideBar: false,
      },
      {
        path: 'attendance/operator',
        id: 'absensi-operator',
        element: <ReportAttendanceOperator />,
        showInSideBar: false,
      },
      {
        path: 'attendance/operator/:date',
        id: 'absensi-operator-detail',
        element: <ReportAttendanceOperatorDetail />,
        showInSideBar: false,
      },
      {
        path: 'host-attendance/:id',
        id: 'absensi-host-detail',
        element: <ReportAttendanceHostDetail />,
        showInSideBar: false,
      },
      {
        path: 'help-partner',
        id: 'help-host-report',
        name: 'Bantu Rekan',
        element: <ReportHelpPartner />,
        showInSideBar: true,
      },
      {
        path: 'host-task',
        id: 'host-task-report',
        name: 'Konten Host',
        element: <ReportHostTasks />,
        showInSideBar: true,
      },
    ],
  },
  {
    path: '/stock-promo',
    icon: <CouponIcon color="var(--color-semantic-text)" />,
    iconActive: <CouponIcon color="var(--color-info60)" />,
    showInSideBar: true,
    exact: true,
    id: 'stock-promotion',
    name: 'Stok & Promo',
    children: [
      {
        path: '',
        id: 'stock-promo',
        name: 'Stok & Promo',
        element: <StockPromo />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/forbidden',
    exact: true,
    children: [
      {
        path: '',
        id: 'forbidden',
        name: 'Forbidden',
        element: <ForbiddenPage />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/version',
    icon: null,
    iconActive: null,
    showInSideBar: false,
    exact: true,
    id: 'version',
    name: 'version',
    children: [
      {
        path: '',
        name: 'Version',
        element: <Version />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/forbidden-schedule',
    icon: null,
    iconActive: null,
    showInSideBar: false,
    exact: true,
    id: 'forbidden-schedule',
    name: 'forbidden schedule',
    children: [
      {
        path: '',
        name: 'forbidden schedule',
        element: <ForbiddenSchedule />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/shopee',
    icon: null,
    iconActive: null,
    showInSideBar: false,
    exact: true,
    id: 'shopee',
    name: 'shopee',
    children: [
      {
        path: 'callback',
        name: 'callback',
        element: <ShopeeCallback />,
        showInSideBar: false,
      },
    ],
  },
];

export const routeListMobile = [
  {
    path: 'login',
    name: 'Login',
    id: 'login',
    children: [
      {
        path: '',
        id: 'login',
        element: <Login />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: 'forgot-password',
    name: 'Forgot Password',
    children: [
      {
        path: '',
        id: 'forgot-password',
        element: <ForgotPassword />,
      },
    ],
  },
  {
    path: 'reset-password/:token',
    name: 'Reset Password',
    children: [
      {
        path: '',
        id: 'reset-password',
        element: <ResetPassword />,
      },
    ],
  },
  {
    path: '/',
    exact: true,
    children: [
      {
        path: '',
        id: 'main-dashboard',
        name: 'Dashboard',
        element: <Home />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/host',
    exact: true,
    children: [
      {
        path: '',
        id: 'host',
        name: 'Host',
        element: <Host />,
        showInSideBar: false,
      },
      {
        path: 'scheduled',
        id: 'host-scheduled',
        name: 'Scheduled',
        element: <HostSchedule />,
        showInSideBar: false,
      },
      {
        path: 'upcoming',
        id: 'host-upcoming',
        name: 'Upcoming Schedule',
        element: <HostSchedule />,
        showInSideBar: false,
      },
      {
        path: 'past',
        id: 'host-past',
        name: 'Past Schedule',
        element: <HostSchedule />,
        showInSideBar: false,
      },
      {
        path: 'detail/:id',
        id: 'host-detail',
        name: 'Host Detail',
        element: <HostDetail />,
        showInSideBar: false,
      },
      {
        path: 'help-request-form',
        id: 'host-help-partner',
        name: 'Host Help Partner',
        element: <HostHelpPartner />,
        showInSideBar: false,
      },
      {
        path: 'stock-promo',
        id: 'host-stock-promo',
        name: 'Host Stock Promo',
        element: <HostStockPromo />,
        showInSideBar: false,
      },
      {
        path: 'achievement-detail',
        id: 'host-achievement-detail',
        name: 'Host Achievement Detail',
        element: <HostAchievementDetail />,
        showInSideBar: false,
      },
      {
        path: 'task-submission',
        id: 'host-task-submission',
        name: 'Task Submission',
        element: <HostTaskSubmission />,
      },
      {
        path: 'attendance-record',
        id: 'attendance-record',
        name: 'Attendance Record',
        element: <HostAttendance />,
        showInSideBar: false,
      },
      {
        path: 'stream',
        id: 'stream',
        name: 'Stream',
        element: <HostStream />,
        showInSideBar: false,
      },
      {
        path: 'presence-content',
        id: 'presence-content',
        name: 'Presence Content',
        element: <HostPresenceContent />,
        showInSideBar: false,
      },
      {
        path: 'brief-live',
        id: 'brief-live',
        name: 'Brief Live',
        element: <BriefLiveHost />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: 'reschedule-form/:id',
    name: 'Reschedule Form',
    children: [
      {
        path: '',
        element: <RescheduleForm />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/forbidden',
    exact: true,
    children: [
      {
        path: '',
        id: 'forbidden',
        name: 'Forbidden',
        element: <ForbiddenPage />,
        showInSideBar: false,
      },
    ],
  },
  {
    path: '/version',
    icon: null,
    iconActive: null,
    showInSideBar: false,
    exact: true,
    id: 'version',
    name: 'version',
    children: [
      {
        path: '',
        name: 'Version',
        element: <Version />,
        showInSideBar: true,
      },
    ],
  },
  {
    path: '/forbidden-schedule',
    icon: null,
    iconActive: null,
    showInSideBar: false,
    exact: true,
    id: 'forbidden-schedule',
    name: 'forbidden schedule',
    children: [
      {
        path: '',
        name: 'forbidden schedule',
        element: <ForbiddenSchedule />,
        showInSideBar: false,
      },
    ],
  },
];
